import React from 'react';
import {env} from '../../context/context';
import Section from '../../libs/react-components-admin/section/section';

class FormPreview extends React.Component {

  constructor(props) {
    super(props);
    this.anchorContainerRef = React.createRef();
    this.renderFormWithDebounce = this.debounce(
      () => this.renderForm(),
      700
    );
    this.state = {
      form: props.form,
    };
  }

  static getDerivedStateFromProps(nextProps) {
    return { form: nextProps.form };
  }

  componentDidMount() {
    this.loadCustomFormsClient()
      .then(() => {
        window.acerillCustomForms.addCssToHead();
        this.renderFormWithDebounce();
      })
      .catch(err => window.alert(err.stack || JSON.stringify(err)));
  }

  componentDidUpdate() {
    this.renderFormWithDebounce();
  }

  renderForm() {
    if (!this.state.form || !this.anchorContainerRef.current ||
      !(window.acerillCustomForms || {}).renderForm) {
      return;
    }
    this.anchorContainerRef.current.textContent = '';
    const anchor = document.createElement('div');
    this.anchorContainerRef.current.appendChild(anchor);
    window.acerillCustomForms.renderForm(anchor, this.state.form, true);
  }

  debounce(fn, waitInMillis) {
    let timer;
    return () => {
      if (timer) {
        window.clearTimeout(timer);
      }
      window.setTimeout(fn, waitInMillis);
    };
  }

  loadCustomFormsClient() {
    const url = env === 'production' ?
      'https://custom-forms-client.acerill.com/js/custom-forms-v2.js' :
      'https://custom-forms-client.acerill-staging.co.uk/js/custom-forms-v2.js';
    const head = document.head;
    if ([ ...head.childNodes ].some(child => child.src === url)) {
      return Promise.resolve();
    } else {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.type = 'text/javascript';
        script.async = true;
        script.src = url;
        script.onload = resolve;
        script.onerror = reject;
        head.appendChild(script);
      });
    }
  }

  render() {
    return <Section title="Preview">
      <div className="form-text">This preview is indicative only, the form will look different on your website because of your theme styles.</div>
      <div ref={this.anchorContainerRef} />
    </Section>;
  }

}

export default FormPreview;
